import { Meteor } from 'meteor/meteor';
import { check } from 'meteor/check';
import Projects from '../Projects';
import Videos from '../../Videos/Videos';
import { getProject } from '../../Videos/video-operations';

// Project Schema
// owner
// createdAt
// updatedAt
// name
// description
// shared
// mapLocation
// deleted
// done

Meteor.publish('projects', function projects() {
  return Projects.find({ owner: this.userId });
});

// Note: projects.view is also used when editing an existing document.
Meteor.publish('projects.view', function projectsView(projectId) {
  check(projectId, String);
  return Projects.find({ _id: projectId, owner: this.userId });
});

Meteor.publish('projects.public', projectId => {
  check(projectId, String);
  return Projects.find(
    { _id: projectId, shared: true },
    {
      fields: {
        owner: 0,
        createdAt: 0,
        updatedAt: 0,
        done: 0
      }
    }
  );
});

Meteor.publish('projects.video', function projectsVideo(videoId, isPublic = false) {
  check(videoId, String);
  const video = Videos.findOne(videoId);
  const projectId = getProject(video);
  const projectQuery = { $or: [{ _id: projectId }] };
  if (isPublic) projectQuery.$or.push({ owner: this.userId });
  return Projects.find(projectQuery, { fields: { deleted: 1, name: 1 } });
});
